var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { GptGeneratedContent } from './gpt-generated-content';
import { GptSourceList } from './gpt-source-list';
import { GptOutputControls } from './gpt-output-controls';
import { classNames } from '@shapeable/utils';
var cls = classNames('gpt-output-content');
export var GptOutputContentDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    padding: 0 ", " ", ";\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ", ";\n    width: 100%;\n    box-sizing: border-box;\n\n    ", "\n  "], ["\n    display: flex;\n    padding: 0 ", " ", ";\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ", ";\n    width: 100%;\n    box-sizing: border-box;\n\n    ", "\n  "])), theme.UNIT(4), theme.UNIT(6), theme.UNIT(4), function (_a) {
    var langName = _a.langName;
    return langName === 'Arabic' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      align-items: flex-end;\n    "], ["\n      align-items: flex-end;\n    "])));
  })
});
var ContentStylesStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-top: 0;\n  "], ["\n    padding-top: 0;\n  "])))
});
var SourcesStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(GptGeneratedContent)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContentStylesStyles),
  Sources: styled(GptSourceList)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SourcesStyles),
  Controls: styled(GptOutputControls)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
export var GptOutputContent = function (props) {
  var className = props.className,
    onCollapseClick = props.onCollapseClick,
    text = props.text,
    sources = props.sources,
    activeLanguage = props.activeLanguage;
  return React.createElement(My.Container, {
    className: cls.name(className),
    langName: activeLanguage === null || activeLanguage === void 0 ? void 0 : activeLanguage.name
  }, React.createElement(My.Content, {
    text: text,
    activeLanguage: activeLanguage
  }), React.createElement(My.Sources, {
    items: sources
  }), React.createElement(My.Controls, {
    onCollapseClick: onCollapseClick,
    text: text
  }));
};
GptOutputContent.cls = cls;
GptOutputContent.defaultProps = GptOutputContentDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;